import React, { Suspense } from "react";
import PortalPreloader from "../../components/preloader/PortalPreloader";
import MyTrips from "../../components/trips/myTrips/MyTrips";


const MyTripsPage = () => {
  return (
    <Suspense fallback={<PortalPreloader />}>
      <MyTrips />
    </Suspense>
  );
};

export default MyTripsPage;
